import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.5 5C10.7761 5 11 5.22386 11 5.5V10.5C11 10.7761 10.7761 11 10.5 11C10.2239 11 10 10.7761 10 10.5V5.5C10 5.22386 10.2239 5 10.5 5Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.5 4C12.7761 4 13 4.22386 13 4.5V11.5C13 11.7761 12.7761 12 12.5 12C12.2239 12 12 11.7761 12 11.5V4.5C12 4.22386 12.2239 4 12.5 4Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5.5 6L9 3V13L5.5 10V6Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3 7C3 6.44772 3.44772 6 4 6H5V10H4C3.44772 10 3 9.55228 3 9V7Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }